import { render, staticRenderFns } from "./GsaNavigator.vue?vue&type=template&id=3c8449bf&scoped=true&"
import script from "./GsaNavigator.vue?vue&type=script&lang=js&"
export * from "./GsaNavigator.vue?vue&type=script&lang=js&"
import style0 from "./GsaNavigator.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GsaNavigator.vue?vue&type=style&index=1&id=3c8449bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8449bf",
  null
  
)

export default component.exports